<template>
  <!-- 发货提提醒框 -->
  <div class="oderTips_box" v-if="thisOderFlag" @click="closeOderModel()">
    <div class="oderTips" @click.stop="">
      <div class="oderTips_close closeOderTips" @click="closeOderModel()">
        <i class="iconfont iconreeor"></i>
      </div>
      <div class="oderTips_title">发货提醒</div>
      <div class="oderTips_content">
        <p>亲爱的{{ oderFlag[0].consignee }}学员：</p>
        <div v-for="(item, index) in oderFlag" :key="index">
          <p>您{{ item.title }}</p>
          <p>已于{{ item.create_time }}发货</p>
          <p class="oderNum">
            运单号为：
            <span class="copyContent">{{ item.tracking_number }}</span>
            <span class="copy_oderNum" @click="copy(item.tracking_number)"
              >复制</span
            >
          </p>
        </div>
        <p>请及时关注！谢谢</p>
      </div>
      <div class="oderTips_footer">
        <!-- <a href="javascript:;">
                <div class="oderTips_btn">
                    查看物流
                </div>
            </a> -->
        <a href="javascript:;">
          <div class="oderTips_btn" @click="closeOder('jump')">查看订单</div>
        </a>
        <a href="javascript:;">
          <div class="oderTips_btn closeOderTips" @click="closeOder()">
            我知道了
          </div>
        </a>
      </div>
    </div>
    <!-- 运单号复制框 -->
    <input type="text" id="copyContent" :value="oderNum" ref="copyOderNum" />
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      // 当前弹框是否显示
      thisOderFlag: false,
      // 复制订单号
      oderNum: null,
    };
  },
  methods: {
    // 关闭当前提示框
    closeOderModel() {
      this.thisOderFlag = false;
    },
    // 复制订单号
    copy(item) {
      this.oderNum = item;
      var that = this
      setTimeout(()=>{
        that.$refs.copyOderNum.select();
        document.execCommand("copy");
        that.$message({
          message: "运单复制成功",
          type: "success",
        });
      })
    },
    // 这个订单朕已阅不用再弹了
    closeOder(item) {
      this.$axios
        .get('/orderDelivery',{
          params: {
            token: localStorage.getItem("token"),
            agency_id: localStorage.getItem("agency_id"),
          },
        })
        .then((doc) => {
            console.log(doc)
            this.closeOderModel()
            if(item == 'jump'){
                let origin = window.location.origin
                window.location.href = origin + '/my_order?order=buy'
            }
        })
        .catch((err) => {
            console.log(err);
        });
    },
  },
  mounted() {
    console.log("组件触发");
  },
  computed: {
    // 接收vuex中的值
    ...mapState(["oderFlag"]),
  },
  watch: {
    oderFlag(N, O) {
      console.log(N);
      console.log(O);
      if (this.oderFlag != null) {
        this.thisOderFlag = true;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.editP {
  line-height: 20px;
  height: 20px !important;
}

.copy_oderNum {
  cursor: pointer;
  text-decoration: underline;
}

.copy_oderNum:hover {
  color: #e9613b;
}

#copyContent {
  position: relative;
  height: 1px;
  bottom: 0;
  z-index: -10;
  border: none;
  opacity: 0;
}

.oderTips_box {
  position: fixed;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  z-index: 999;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}

.oderTips_box p {
  margin: 0 0 10px 0;
}

.oderTips {
  position: relative;
  min-width: 340px;
  background-color: #fff;
  display: inline-block;
  padding: 20px;
  width: auto;
  height: auto;
  /* border: 1px solid #666; */
  border-radius: 8px;
}

.oderTips_close {
  cursor: pointer;
  position: absolute;
  right: 10px;
  top: 10px;
}

.iconreeor:before {
  font-size: 25px;
}

.oderTips_title {
  margin-bottom: 10px;
  text-align: center;
  font-size: 16px;
  font-weight: bold;
  /* color: #86A4B9; */
}

.oderTips_footer {
  border-top: 1px dashed #90b0c5;
  padding-top: 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.oderTips_btn {
  cursor: pointer;
  text-align: center;
  height: 30px;
  width: 80px;
  border-radius: 15px;
  line-height: 30px;
  margin-left: 10px;
  background-color: rgba(217, 87, 59, 1);
  color: #fff;
}

@font-face {
  font-family: "iconfont";
  /* Project id 2262606 */
  src: url("//at.alicdn.com/t/font_2262606_c5mth1x6jp7.woff2?t=1649142198283")
      format("woff2"),
    url("//at.alicdn.com/t/font_2262606_c5mth1x6jp7.woff?t=1649142198283")
      format("woff"),
    url("//at.alicdn.com/t/font_2262606_c5mth1x6jp7.ttf?t=1649142198283")
      format("truetype");
}

.iconfont {
  font-family: "iconfont" !important;
  font-size: 16px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.iconreeor:before {
  content: "\e75e";
}
</style>

